<template>
    <button
      :class="[
        'rounded-lg',
        disableText ? 'py-3' : iconBefore || iconAfter ? 'py-6' :'py-4',
        disableText ? 'px-5' : 'px-8',
        'float-inherit',
        'text-white',
        buttonClass,
        'hover:bg-blue-700',
        'focus:outline-none',
        'text-sm',
        'font-semibold',
        'max-h-50',
        {'opacity-50 cursor-not-allowed': disabled},
        {'flex items-center': iconBefore || iconAfter},
        {'justify-center': !iconBefore && !iconAfter},
      ]"
      @click="handleClick"
      class="flex items-center"
      :disabled="disabled"
    >
      <img v-if="iconBefore" :class="{'mr-2' : !disableText}" :src="iconBefore" :width="imgWidth" :alt="buttonText+'-icon'">
      <p v-if="!disableText" class="l">{{ buttonText }}</p>
      <img v-if="iconAfter" :class="{'ml-2' : !disableText}" :src="iconAfter" :width="imgWidth" :alt="buttonText+'-icon'">
    </button>
  </template>
  
  <script>
  export default {
    name: "Button",
    props: {
      buttonText: {
        type: String,
        default: 'Enter Text...',
      },
      iconBefore: {
        type: String,
        default: null,
      },
      iconAfter: {
        type: String,
        default: null,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      disableText: {
        type: Boolean,
        default: false,
      },
      buttonType: {
        type: String,
        default: 'primary',
      },
      imgWidth: {
        type: String,
        default: '20px',
      },
    },
    computed: {
        buttonClass(){
            let colorClass = "ns-button-primary";
            if(this.buttonType == 'primary') {
                colorClass = "ns-button-primary";
            }else if(this.buttonType == 'light'){
                colorClass = "ns-button-light";
            } else if(this.buttonType == 'dark'){
                colorClass = "ns-button-dark";
            } else if(this.buttonType == 'light-2'){
                colorClass = "ns-button-light-2";
            }
            return colorClass;
        }
    },
    methods: {
      handleClick() {
        this.$emit("click");
      },
    },
  };
  </script>
  
  <style scoped>
  button {
    transition: background-color 0.2s ease-in-out, border-color 0.2s ease-in-out;
  }
  .ns-button-primary{
    color: #FFFFFF;
    background: #F9A168;
  }
  .ns-button-light{
    color: #111;
    background: #FFFFFF;
  }
  .ns-button-dark{
    color: #FFFFFF;
    background: #111;
  }
  .float-inherit{
    float: inherit;
  }
  .max-h-50{
    max-height: 50px !important;
  }
  .ns-button-light-2{
    background-color: #fff;
    border: 1px solid #F9A168;
    border-radius: 8px;
    color: #F9A168;
  }
  </style>
  